import { Box } from "@chakra-ui/react";
import React from "react";
import ReactPaginate from "react-paginate";
import { COLORS } from "../../../../Helper/Colors";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const Pagination = ({ total, pageSize, currentPage, handlePageChange, ...rest }) => {
	return (
		<Box position={"absolute"} bottom={rest.bottom || -2} top={rest.top} left={"50%"} transform={"translate(-50%, 0)"}>
			<ReactPaginate
				previousLabel={
					<FontAwesomeIcon icon={faArrowLeft} size={rest.iconSize || "1x"} color={rest.iconColor || COLORS.light} />
				}
				nextLabel={<FontAwesomeIcon icon={faArrowRight} size={rest.iconSize || "1x"} color={rest.iconColor || COLORS.light} />}
				pageClassName='page-item'
				pageLinkClassName='page-link'
				previousClassName='page-item'
				previousLinkClassName='page-link'
				nextClassName='page-item'
				nextLinkClassName='page-link'
				breakLabel='...'
				breakClassName='page-break'
				breakLinkClassName='page-link'
				pageCount={Math.ceil(total / pageSize)}
				marginPagesDisplayed={2}
				pageRangeDisplayed={5}
				onPageChange={handlePageChange}
				containerClassName='pagination'
				activeClassName='active'
				renderOnZeroPageCount={null}
				forcePage={currentPage - 1}
			/>
		</Box>
	);
};
